import React from 'react'

import { Layout2Col } from '../../components/layouts'
import Logo from '../../masalogo.png'
import { SignUpFlow } from './sign-up-flow'

export function SignUp() {
    return (
        <Layout2Col
            hideLeft={true}
            left={
                <div className='flex flex-col justify-between h-full'>
                    <img src={Logo} alt={'Masa Logo'} className='h-11 w-48' />
                    <p className='max-w-md text-xl'>
                        <strong>Masa</strong> is a{' '}
                        <strong>decentralized financial identity</strong> that
                        allows you to connect your centralized finance CeFi
                        accounts to the DeFi apps you <strong>love</strong>
                    </p>
                </div>
            }
            right={<SignUpFlow />}
        />
    )
}
